export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
}

export const categories: Category[] = [
  {
    slug: 'japan',
    name: '日本电影',
    description: '最新日本电影推荐，涵盖文艺、动画、悬疑等多种类型，感受日本电影的独特魅力。',
    icon: 'ri-earth-line',
    color: 'primary',
  },
  {
    slug: 'korea',
    name: '韩国电影',
    description: '韩国电影佳作合集，从犯罪动作到历史剧情，体验韩国电影的制作水准与故事魅力。',
    icon: 'ri-flag-line',
    color: 'accent',
  },
  {
    slug: 'anime',
    name: '动漫剧场版',
    description: '日韩精品动画电影，包括宫崎骏、新海诚等大师作品及热门IP剧场版，视觉与情感的双重盛宴。',
    icon: 'ri-movie-2-line',
    color: 'secondary',
  },
  {
    slug: 'theater',
    name: '剧场版合集',
    description: '经典日剧韩影剧场版，大银幕级别的制作水准，在大荧幕上延续热爱的故事。',
    icon: 'ri-film-line',
    color: 'primary',
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};